<template>
    <div>
        <page-header page-title="Etapas do Loteamento" filter @filter="setModalFilter" :btn-new="'Novo'" @newType="setRegisterModal"></page-header>
        <load-screen-component></load-screen-component>
        <table-component :titles="['Etapas', 'Loteamento']">
            <template #tableBody>
                <tr v-for="(iten, key) in steps?.data" :key="key">
                    <td>{{ iten.name }}</td>
                    <td>{{ iten.allotment_name }}</td>
                    <td class="text-center ">
                        <a type="button" data-toggle="dropdown" aria-haspopup="true"
                           aria-expanded="false" style="font-size: 20px" id="listDropdown">
                            <i class="icon-arrow_drop_down"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right dropdown-black dropdown-menu-custom w-auto"
                             id="dropdownMenu">
                            <div @click="setViewModal(iten.id)" class="dropdown-item pointer text-white"
                                 data-target="#customModalTwo" data-toggle="modal">
                                <i class="icon-eye1 mr-2 font-15"/>{{ t('STEPS.VIEW') }}
                            </div>
                            <div @click="setEditModal(iten.id)" class="dropdown-item pointer text-white"
                                 data-target="#customModalTwo" data-toggle="modal">
                                <i class="icon-pencil mr-2 font-15"/>{{ t('STEPS.EDIT') }}
                            </div>
                            <div @click="deleteStep(iten.id)" class="dropdown-item pointer text-white">
                                <i class="icon-trash mr-2 font-15"/>{{ t('STEPS.DELETE') }}
                            </div>
                        </div>
                    </td>
                </tr>
                <tr v-if="!steps?.data">
                    <td colspan="100">
                        <div class="w-100 p-4 text-center">
                            <h5>{{ t('STEPS.NONE_FOUND') }}</h5>
                        </div>
                    </td>
                </tr>
            </template>
        </table-component>
        <modal modal-large :title-modal="modalTitle" @close="closeModal">
            <template #title>{{ t(modalTitle) }}</template>
            <modal-crud-component v-if="modalWhich === 1" :is-create="isCreate" :is-view="isView" :is-edit="isEdit"
               :step-index="step" :templates="templates" @updated="updated"></modal-crud-component>
            <div v-if="modalWhich === 2">
                <div class="modal-body">
                    <div class="row gutters">
                        <div class="col-6">
                            <div class="form-group">
                                <label>Nome</label>
                                <input type="text" placeholder="Nome" v-model="filter.name" class="form-control">
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label>Loteamento</label>
                                <select2 v-model="filter.allotment_id" :options="[{id:'selecione', text:'Selecione'}, ...allotments]" :settings="{width: '100%'}"
                                    placeholder="Selecione"></select2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="btn btn-secondary" @click="clearFilter">Limpar</div>
                    <div class="btn btn-primary" data-dismiss="modal" @click="index(filter)">Filtrar</div>
                </div>
            </div>
        </modal>
        <pagination-component v-if="steps?.data && steps.data[0]" :items="steps" to="/etapas"
                              @changePage="index(filter, $event)"></pagination-component>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import pageHeader from '../../components/layouts/pageHeader';
import loadScreenComponent from '../../components/layouts/loadScreenComponent';
import tableComponent from '../../components/layouts/tableComponent';
import Steps from '../../services/Steps';
import PaginationComponent from '../../components/layouts/PaginationComponent';
import modal from '../../components/modal';
import modalCrudComponent from './modalCrudComponent';
import Proposal from '../../services/Proposal';
import Select2 from 'vue3-select2-component';
import {mapState} from 'vuex';


export default {
    name: "indexStepComponent",
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast};
    },
    components: {
        pageHeader,
        modal,
        loadScreenComponent,
        tableComponent,
        PaginationComponent,
        modalCrudComponent,
        Select2,
    },
    computed:{
        ...mapState({allotments:'allotments'})
    },
    data() {
        return {
            steps: {},
            filter: {},
            step: {},
            templates: {},
            modalTitle: '',
            modalWhich: null,
            isCreate: null,
            isView: null,
            isEdit: null,
        }
    },
    mounted() {
        this.$store.commit('changeLoading', true);
        this.index();
    },
    methods: {
        setModalFilter(){
            this.modalWhich = 2;
            this.modalTitle = 'Filtrar';
        },
        clearFilter() {
            document.getElementById('closeX')?.click();
            this.filter = {};
            this.index();
        },
        closeModal(){
            this.modalWhich = null;
            this.modalTitle = '';
            this.isView = false;
            this.isEdit = false;
            this.isCreate = false;
            this.step = {};
        },
        deleteStep(id){
            this.$swal.fire({
                title: this.t('GENERAL.MSG.REALLY_WANT_DELETE'),
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Excluir`,
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    Steps.delete(id).then(() => {
                        this.toast.success(this.t('GENERAL.MSG.DELETED_SUCCESS'));
                        this.index();
                    }).catch((err) => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(err);
                    })
                }
            });
        },
        updated(){
            document.getElementById('closeX')?.click();
            this.index();
        },
        setRegisterModal(){
            this.step = {};
            this.modalTitle = 'Criar Etapa';
            this.modalWhich = 1;
            this.isView = false;
            this.isEdit = false;
            this.isCreate = true;
            this.listTemplateProposals();
        },
        setEditModal(id){
            this.$store.commit('changeLoading', true);
            this.modalTitle = 'Editar Etapa';
            this.modalWhich = 1;
            this.isView = false;
            this.isEdit = true;
            this.isCreate = false;
            this.listTemplateProposals();
            Steps.view(id).then(resp => {
                this.step = resp.data;
                this.$store.commit('changeLoading', false);
            }).catch(() => this.$store.commit('changeLoading', false));
        },
        setViewModal(id){
            this.$store.commit('changeLoading', true);
            this.modalTitle = 'Vizualizar Etapa';
            this.modalWhich = 1;
            this.isView = true;
            this.isEdit = false;
            this.isCreate = false;
            this.listTemplateProposals();
            Steps.view(id).then(resp => {
                this.step = resp.data;
                this.$store.commit('changeLoading', false);
            }).catch(() => this.$store.commit('changeLoading', false));
        },
        index(filter = {}, page = 1) {
            this.$store.commit('changeLoading', true);
            Steps.index(filter, page).then(resp => {
                this.steps = resp.data;
                this.$store.commit('changeLoading', false);
            }).catch(() => this.$store.commit('changeLoading', false));
        },
        listTemplateProposals() {
            Proposal.listTemplate().then(resp => this.templates = resp.data);
        },
    }
}
</script>

<style scoped>

</style>